import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, pw);
      toast.success(`Bienvenido, ${u.full_name}`);
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-1 bg-slate-900 text-white items-end p-12 grid-bg" style={{ backgroundColor: "#0f172a" }}>
        <div>
          <Link to="/" className="font-display font-extrabold text-2xl tracking-tight">AutoPresupuestos<span className="text-orange-500">.</span></Link>
          <h2 className="font-display font-extrabold text-4xl mt-12 leading-tight">Genera presupuestos<br/>como un profesional<br/><span className="text-orange-500">en 30 segundos.</span></h2>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={onSubmit} className="w-full max-w-sm">
          <div className="kbar mb-2">Iniciar sesión</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Bienvenido de vuelta</h1>
          <p className="text-slate-500 mt-2 text-sm">¿No tienes cuenta? <Link to="/register" className="text-orange-600 font-semibold">Regístrate gratis</Link></p>

          <label className="kbar mt-8 block">Email</label>
          <input
            data-testid="login-email"
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full h-12 mt-2 px-3 border border-slate-200 focus:border-orange-600 focus:ring-2 focus:ring-orange-100 outline-none"
            autoComplete="email"
          />
          <label className="kbar mt-5 block">Contraseña</label>
          <input
            data-testid="login-password"
            type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full h-12 mt-2 px-3 border border-slate-200 focus:border-orange-600 focus:ring-2 focus:ring-orange-100 outline-none"
            autoComplete="current-password"
          />
          <button data-testid="login-submit" disabled={loading} className="btn-brand h-12 w-full mt-8 inline-flex items-center justify-center disabled:opacity-50">
            {loading ? "Entrando…" : "Entrar"}
          </button>
          <div className="mt-6 text-xs text-slate-400 text-center">Demo admin: admin@autopresupuestos.com · admin1234</div>
        </form>
      </div>
    </div>
  );
}
